import { recentSearchDuckCreator } from 'axl-ducks';
import { createSelector, DuckSelector } from '@atc/modular-redux';
import { getPersonalizationClientEnv } from './duckUtils';

const recentSearchDuck = recentSearchDuckCreator({
    ...getPersonalizationClientEnv(),
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {

            case types.SET_RECENT_SEARCHES: {
                return {
                    ...state,
                    recentSearchesAreSet: true,
                };
            }

            default:
                return state;
        }
    },
    selectors: {
        fetchedRecentSearchLocalStorage: (state) => state.recentSearch.recentSearchesAreSet,
        getRecentSearchQuery: new DuckSelector((selectors) => createSelector(
            selectors.getRecentSearches,
            (recentSearches) => recentSearches?.[0]?.query || false
        )),
    },
});

export default recentSearchDuck;
